// Sentry initialization should be imported first!
import './sentry.ts';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';
import './styles/themes.css';
import './styles/range-input.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />
);
